module.exports = function(login) {
	"use strict";
	login.controller('loginCtrl', loginCtrl);
	loginCtrl.$inject = ['$scope', '$rootScope'];
	function loginCtrl($scope, $rootScope) {
		var vml = this;
		vml.userName = '';
		vml.password = '';
		
		// });
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/loginModule/js/loginController.js
// module id = 504
// module chunks = 0